








































































































































































































































import { Component, Vue, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
const Debtors = namespace("DebtorsModule");
import { VueTelInput } from "vue-tel-input";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import {
  required,
  max,
  numeric,
  regex,
  email,
  min,
} from "vee-validate/dist/rules";
import BankInfo from "@/components/BankInfo.vue";
import Country from "@/components/Country.vue";
import InvoiceType from "@/components/InvoiceType.vue";
import NotificationMixin from "@/mixins/notification.mixin";

// Add the rules
extend("required", {
  ...required,
  message: "This field is required",
});
extend("email", {
  ...email,
  message: "The field must be a email address.",
});
extend("max", {
  ...max,
  params: ["length"],
  message: "Max length {length}",
});
extend("min", {
  ...max,
  params: ["length"],
  message: "Min length {length}",
});
extend("numeric", {
  ...numeric,
  message: "Field type must be numeric",
});
extend("regex", {
  ...regex,
  message: "The field must contain only decimal values, ex: 0.00",
});

@Component({
  name: "DebtorAdd",
  mixins: [NotificationMixin],
  components: {
    VueTelInput,
    ValidationProvider,
    ValidationObserver,
    BankInfo,
    Country,
    InvoiceType,
  },
})
export default class DebtorAdd extends Mixins(NotificationMixin) {
  @Debtors.State
  public debtorData!: Array<any>;

  @Debtors.Action
  public retrieveDebtorById!: (params: number) => Promise<any>;

  @Debtors.Action
  public addDebtor!: (data: any) => Promise<any>;

  @Debtors.Action
  public editDebtor!: (data: any) => Promise<any>;

  private IDGen = 4000000000;

  private ClickAddMore = false;
  private showButtonAddMore = true;
  private invoiceTypeOptions: Array<any> = [];
  private isLoading = false;

  private BankAddMore = [
    {
      BankAccType: "",
      BankAccNr: "",
      BankCurrCode: "",
      BankTypePrimary: 203201,
      BankName: "",
      BankSwiftAddress: "",
    },
  ];

  private debtorField = {
    AdmNr: 0,
    Debtor: 0,
    Name: "",
    SearchCode: "",
    Country: "",
    PostalCode: "",
    Address1: "",
    City: "",
    Telephone: "",
    Email: "",
    BankInfo: [
      {
        BankAccType: "",
        BankAccNr: "",
        BankCurrCode: "",
        BankTypePrimary: 0,
        BankName: "",
        BankSwiftAddress: "",
      },
    ],
    CustomField: {
      MainContactName: "",
      MainContactEmail: "",
      DutchCompany: "",
      Tax: "",
      RegisterName: "",
      InvoiceType: [],
      VAT: "",
    },
  };

  created() {
    this.getDebtorData();
  }

  isAddDebtor() {
    return this.$route.params.debtorId == undefined;
  }

  onInput(formattedNumber: any, { number, valid, country }: any) {
    if (number.input == "00" || number.input == "+00") {
      this.debtorField.Telephone = "+";
    } else if (number.international) {
      this.debtorField.Telephone = number.international;
    }
  }

  getDebtorData() {
    if (!this.isAddDebtor()) {
      this.retrieveDebtorById(parseInt(this.$route.params.debtorId)).then(
        (response) => {
          response.CustomField.Tax = parseFloat(
            response.CustomField.Tax
          ).toFixed(2);
          response.CustomField.VAT = parseFloat(
            response.CustomField.VAT
          ).toFixed(2);
          this.debtorField = response;
          this.onUpdateInvoiceType();
        },
        (error) => {
          this.onShowFlashMessage(error, "Error", "danger");
        }
      );
    }
  }

  onSubmit() {
    this.isLoading = true;
    const insertData = {
      Name: this.debtorField.Name,
      SearchCode: this.debtorField.SearchCode,
      Country: this.debtorField.Country,
      PostalCode: this.debtorField.PostalCode,
      Address1: this.debtorField.Address1,
      City: this.debtorField.City,
      Telephone: this.debtorField.Telephone.replace(/\s/g, ""),
      Email: this.debtorField.Email,
      BankInfo: {},
      CustomField: this.debtorField.CustomField,
    };
    if (this.isAddDebtor()) {
      // Case Add Debtor
      insertData.BankInfo = {
        BankTypePrimary: 203201,
        BankAccType: this.debtorField.BankInfo[0].BankAccType,
        BankAccNr: this.debtorField.BankInfo[0].BankAccNr,
        BankCurrCode: this.debtorField.BankInfo[0].BankCurrCode,
        BankName: this.debtorField.BankInfo[0].BankName,
        BankSwiftAddress: this.debtorField.BankInfo[0].BankSwiftAddress,
      };
      this.onAddDebtor(insertData);
    } else {
      // Case Edit Debtor
      if (this.BankAddMore[0].BankAccType !== "") {
        // Has bank info
        insertData.BankInfo = this.BankAddMore[0];
      }
      if (Object.keys(insertData.BankInfo).length == 0) {
        delete insertData.BankInfo;
      }
      // Call Update func
      this.onUpdateDebtor(insertData);
    }
    this.ClickAddMore = false;
    this.showButtonAddMore = true;
    this.onUpdateInvoiceType();
  }

  onAddDebtor(data: any) {
    this.addDebtor(data).then(
      (response) => {
        if (response.Error) {
          this.onShowFlashMessage(response.Error.message, "Error", "danger");
        } else {
          this.debtorField = response;
          setTimeout(() => {
            this.$router.push({
              name: "DebtorDetails",
              params: { debtorId: response.Debtor },
            });
          }, 2000);
          this.onShowFlashMessage("Created Debtor Successfully!");
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  onUpdateDebtor(data: any) {
    data.Debtor = this.$route.params.debtorId;
    this.editDebtor(data).then(
      (response) => {
        if (response.Error) {
          this.onShowFlashMessage(response.Error.message, "Error", "danger");
        } else {
          this.debtorField = response;
          
          setTimeout(() => {
            this.$router.push({
              name: "DebtorDetails",
              params: { debtorId: this.$route.params.debtorId },
            });
          }, 2000);
          this.onShowFlashMessage("Updated Debtor Successfully!");
        }
        this.isLoading = true;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  // ---- Handling BankInfo ----
  addFormBank() {
    if (this.ClickAddMore) {
      this.BankAddMore.push({
        BankAccType: "",
        BankAccNr: "",
        BankCurrCode: "",
        BankTypePrimary: 0,
        BankName: "",
        BankSwiftAddress: "",
      });
    } else {
      this.ClickAddMore = true;
    }
    this.showButtonAddMore = false;
  }

  removeBankAddMore(index: any) {
    this.BankAddMore = this.BankAddMore.filter((con, idx) => idx !== index);
    this.showButtonAddMore = true;
  }
  // ---- End Handling BankInfo ----

  onUpdateInvoiceType() {
    // Get options of invoice types
    this.invoiceTypeOptions = [];
    for (const opt of this.debtorField.CustomField.InvoiceType) {
      this.invoiceTypeOptions.push({ text: opt, value: opt });
    }
  }
}
